package landing.model


import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import landing.ds.ResourceSlogan
import landing.model.state.SloganPagerState

class ComingSoonModel : ViewModel() {
    private val timeoutDuration = 6000L
    private val _uiState = MutableStateFlow(SloganPagerState(
        nextPage = 0
    ))
    val uiState: StateFlow<SloganPagerState> = _uiState
    private var timeOutJob = viewModelScope.launch {
        delay(timeoutDuration)
        onClick()
    }

    fun onClick() {
        _uiState.value = _uiState.value.copy(
            nextPage = (_uiState.value.nextPage + 1) % ResourceSlogan.resourceSlogans.size
        )
        timeOutJob.cancel()
        timeOutJob = viewModelScope.launch {
            delay(timeoutDuration)
            onClick()
        }
    }
}
